import IntegrationSettingCard from './integrationSettingCard.container';

export default IntegrationSettingCard;